import { PaymentStatuses } from "@app/screens/ConfirmPay/ConfirmPay"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility"
import { getPaymentMode } from "../utils"
import LottieView from 'lottie-react-native';
import lottie from "../../../../assets/lottie/succes_tick.json"
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
import RepayprogresIcon from "../../../../assets/Icons/RepayProgressIcon";

const TataPaymentStatus = ({userPaymentData}:{userPaymentData:any}) => {
    const paymentStatus = userPaymentData?.collectionStatus
    const isPaymentSuccessful = paymentStatus === PaymentStatuses.COLLECTION_COMPLETE || paymentStatus === PaymentStatuses.SETTLED || paymentStatus === PaymentStatuses.SUCCESS_WITH_LENDER_RECON_FAILED
    const isPaymentFailure = paymentStatus === PaymentStatuses.FAILED
    const isPaymentPending = paymentStatus === PaymentStatuses.PENDING_SETTLEMENT;
    const isPaymentCancelled = paymentStatus === PaymentStatuses.CANCELLED;
    const epochFromBackend = userPaymentData?.paymentDate
    const transactionalRefNumber = userPaymentData?.transactionId !== null ? userPaymentData?.transactionId : "Not applicable";
    const bankRefNumber = userPaymentData?.pgResponseDetails !== null && userPaymentData?.pgResponseDetails?.bankRefNo !== null
            ? userPaymentData?.pgResponseDetails?.bankRefNo
            : "Not applicable"
    const paymentMode = 
            userPaymentData?.pgResponseDetails?.paymentMode 
                ? userPaymentData?.pgResponseDetails?.paymentMode === "Unified Payments"
                    ? "UPI" 
                    : getPaymentMode(userPaymentData?.pgResponseDetails?.paymentMode)
                : "Not applicable"
    const dateFromBackend = new Date(userPaymentData?.paymentDate)
    const options = {
        timeZone: 'Asia/Calcutta',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
    };
    //@ts-ignore
    const istTime = dateFromBackend.toLocaleString('en-US', options);
    const paymentDate = epochFromBackend !== null
         ? `${dateFromBackend.toDateString().substring(4, dateFromBackend.toDateString().length - 5)}, ${dateFromBackend.toDateString().substring(dateFromBackend.toDateString().length - 4)} ${istTime}`
         : "";

    const paymentStatusLabel = isPaymentSuccessful ? 'Payment successful' : isPaymentFailure ? 'Payment failed' : isPaymentCancelled ? "Payment failed": 'Payment in progress';

    return (
        <ThemedView style={{marginTop:24}}>
            <ThemedView style={{alignItems:'center'}}>
                {isPaymentSuccessful ? <LottieView
                    source={lottie}
                    style={{width: 70, height: 'auto'}}
                    autoPlay={true}
                    loop={true}
                />
                : isPaymentPending 
                ? <RepayprogresIcon />
                : <WarningCircle  size={48} weight="fill" color={themeColorSet["icon-error"]}/>
                }

            </ThemedView>
            
            <ThemedView mt="lg" style={{alignItems:'center'}}>
                <ThemedText variant="b2r" color="text-secondary">
                    {paymentStatusLabel}
                </ThemedText>
            </ThemedView>
            <ThemedView style={{alignItems:'center'}}>
                <ThemedText variant="l1" color='text-primary' >₹<ThemedText variant='h1b' color='text-primary'>
                    {formatIndianCurrency(userPaymentData.totalAmountDue)}
                    </ThemedText></ThemedText>  
                </ThemedView>
            <ThemedView mt = 'lg' style={{alignItems:'center'}} >
                <ThemedText>
                    {paymentDate}
                </ThemedText>
            </ThemedView>
            {(isPaymentPending || isPaymentCancelled || isPaymentFailure) && (
                <ThemedView mt = 'lg' style={{flexDirection:'row',backgroundColor:'#FEF4E6',paddingHorizontal:16,paddingVertical:8,borderRadius:8}}>
                    <ThemedText>
                        <ThemedText variant='b4s' color='text-primary'>
                            Note:{' '}
                        </ThemedText>
                        <ThemedText variant='b4r' color='text-primary'>
                            {isPaymentPending 
                                ? "Your repayment is being processed. Please wait while we confirm the status of your transaction."
                                : "Any amount deducted from your account will be refunded to your account in 5-7 business days."
                            }
                        </ThemedText>
                    </ThemedText>
                </ThemedView>
            )}
            <ThemedView mt="xl" p="lg" borderRadius="sm" style={{backgroundColor: '#F9FAFB', borderWidth: 1, borderColor: '#E4E7EC'}}>
                <ThemedView>
                    <ThemedText variant="b4r" color="text-secondary">
                        Transaction reference number
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {transactionalRefNumber}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView mt="lg">
                    <ThemedText variant="b4r" color="text-secondary">
                        Bank reference number
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {bankRefNumber}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>

                <ThemedView mt="lg">
                    <ThemedText variant="b4r" color="text-secondary">
                        Payment Method
                    </ThemedText>
                    <ThemedView mt="sm">
                        <ThemedText variant="b4r" color="text-primary">
                            {getPaymentMode(paymentMode)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
        </ThemedView>
    )
}

export default TataPaymentStatus